import { format } from "@itb/ui";

export const sleep = async (ms: number) => await new Promise(r => setTimeout(r, ms));

export const safeOpenUrl = (url: string) => window.open(url, "noopener noreferrer");

const STRATEGY_ID_FORMAT_OVERRIDES: { [key: string]: string } = {
  eigenlayer_staking: "EigenLayer Staking",
  spark_staking: "Sparkdex Staking",
  aavev4_leverage: "Aave V4 Leverage",
  aavev4_leverage_multi: "Aave V4 Leverage Multi",
}

export const format_strategy_id = (strategy_id: string) => STRATEGY_ID_FORMAT_OVERRIDES[strategy_id] ?? strategy_id?.split("_").map(format.capitalize).join(" ");
